import React, { useEffect, useCallback } from 'react';
import { setAttributionAction } from '../../../../../redux/slices/oldBuilder';
import {
  AttributionKey,
  QueryType,
} from '../../../../../utils/apollo/graphqlSchema';
import {
  attributionTooltips,
  retentionAttributionTooltipOption,
} from '../../../../../components/KubitTooltip/globalTooltips';
import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks';
import {
  builderDefaultOptionsSelector,
  builderSelectedOptionsSelector,
} from '../../../../../redux/selectors/builder';
import { assertCondition } from '../../../../../utils/types';
import BuilderEnumSelect from '../../../../../components/Builder/BuilderFields/BuilderEnumSelect';

export default () => {
  const dispatch = useAppDispatch();

  const defaultOptions = useAppSelector(builderDefaultOptionsSelector);
  const selectedOptions = useAppSelector(builderSelectedOptionsSelector);

  assertCondition(
    defaultOptions?.type === QueryType.Retention &&
      selectedOptions?.type === QueryType.Retention,
  );

  const attributionOptions = defaultOptions.attributions;
  const attributionKey = selectedOptions.attribution;

  const menuOptions = attributionOptions.map((atto) => ({
    ...atto,
    tooltip: attributionTooltips[atto.key],
  }));

  const handleAttributionChange = useCallback(
    (value: AttributionKey) => {
      dispatch(setAttributionAction({ attributionKey: value }));
    },
    [dispatch],
  );

  useEffect(() => {
    if (!attributionKey && attributionOptions) {
      handleAttributionChange(attributionOptions[0].key);
    }
  }, [attributionKey, attributionOptions, handleAttributionChange]);

  return (
    <BuilderEnumSelect
      label={'Attribution'}
      enumOptions={menuOptions}
      selectedOption={attributionKey}
      onChange={handleAttributionChange}
      tooltipOption={retentionAttributionTooltipOption}
    />
  );
};
